import React, { useState } from "react";
import { toAbsoluteUrl } from "../../../../../_metronic/_helpers";
import Button from "app/popleads/components/ui-kit/Button";
import SVG from "react-inlinesvg";
import SearchInput from "../../../app/partials/SearchInput";
import { toast } from "react-toastify";

const SaveFilter = ({
    usersFilters,
    isFilterApplied,
    selectedFilterId,
    onFilterSelected,
    saveNewFilter,
    updateFilter,
    deleteSelectedFilter,
    clearAllFilters,
    renameFilter,
    isLoading = false,
    isFilterChanged = true,
    numOfFilters = 4,
}) => {
    const [showAll, setShowAll] = useState(false);
    const [showSaveInput, setShowSaveInput] = useState(false);
    const [savedFilterName, setSavedFilterName] = useState("");
    const [searchFilter, setSearchFilter] = useState("");
    const [editingFilterId, setEditingFilterId] = useState(null);
    const [editingFilterName, setEditingFilterName] = useState("");

    // const saveInputWidth = `${Math.min(savedFilterName ? savedFilterName.length + 3 : 4, 28)}ch`;
    // const renameInputWidth = `${Math.min(Math.max((editingFilterName || "").length + 1, 6), 16)}ch`;

    const onDeleteClicked = (e, id) => {
        e.stopPropagation();
        deleteSelectedFilter(id);
    };

    const onSaveClick = () => {
        if (!isFilterChanged) {
            toast("This filter selection is already up to date.", { type: "warning" });
            return;
        }
        saveNewFilter(savedFilterName);
        setShowSaveInput(false);
        setSavedFilterName("");
    };

    const onCancelClick = () => {
        setShowSaveInput(false);
        setSavedFilterName("");
    };

    const handleKeyPress = (e) => {
        if (e?.key === "Enter") {
            e.preventDefault();
            onSaveClick();
        }
    };

    const onRenameClicked = (e, filter) => {
        e.stopPropagation();
        setEditingFilterId(filter.id);
        setEditingFilterName(filter.name);
    };

    const handleRenameSubmit = (e) => {
        e.stopPropagation();
        if (editingFilterName && editingFilterName.trim() !== "") {
            renameFilter(editingFilterId, editingFilterName);
        }
        setEditingFilterId(null);
        setEditingFilterName("");
    };

    const handleRenameCancel = (e) => {
        e.stopPropagation();
        setEditingFilterId(null);
        setEditingFilterName("");
    };

    let orderedData =
        usersFilters && usersFilters.length > 0
            ? [...usersFilters].sort((a, b) => {
                  if (a.id === selectedFilterId) {
                      return -1;
                  } else if (b.id !== selectedFilterId) {
                      return 1;
                  } else {
                      return 0;
                  }
              })
            : [];

    if (searchFilter) {
        orderedData = orderedData.filter((item) => item.name.toLowerCase().includes(searchFilter.toLowerCase()));
    }

    const isSearching = searchFilter.length > 0;
    const activeFilterId = isFilterApplied ? selectedFilterId : null;
    const numOfFiltersToDisplay = showAll ? orderedData.length : activeFilterId ? numOfFilters + 1 : numOfFilters;

    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-4" style={{ minWidth: "200px" }}>
                {/* <h4 className="drawer-header m-0 py-3">Filters</h4> */}
                <div className="d-flex align-items-center">
                    {isFilterApplied && (
                        <>
                            <Button
                                variant="primary"
                                buttonStyle="borderless"
                                leftIconPath="/media/svg/popleads/refresh.svg"
                                onClick={clearAllFilters}
                                type="button"
                            >
                                {"Reset Filters"}
                            </Button>
                            <Button
                                variant="primary"
                                buttonStyle="borderless"
                                leftIconPath="/media/svg/popleads/save_icon.svg"
                                onClick={() => setShowSaveInput(true)}
                                type="button"
                            >
                                {"Save Selection"}
                            </Button>
                            {selectedFilterId && updateFilter && (
                                <Button
                                    variant="primary"
                                    buttonStyle="borderless"
                                    leftIconPath="/media/svg/popleads/save_icon.svg"
                                    onClick={() => {
                                        if (!isFilterChanged) {
                                            toast("This filter selection is already up to date.", { type: "info" });
                                        } else {
                                            updateFilter(selectedFilterId);
                                        }
                                    }}
                                    type="button"
                                >
                                    {"Update Selection"}
                                </Button>
                            )}
                        </>
                    )}
                </div>
            </div>
            {showSaveInput && (
                <div className="save-filter-input-row mb-4">
                    <input
                        className="save-filter-input"
                        type="text"
                        autoFocus
                        value={savedFilterName}
                        onChange={(e) => setSavedFilterName(e.target.value)}
                        onKeyPress={handleKeyPress}
                    />
                    <div className="save-filter-input-actions">
                        <Button
                            variant="primary"
                            buttonStyle="borderless"
                            disabled={!savedFilterName}
                            onClick={onSaveClick}
                            type="button"
                        >
                            {"Save"}
                        </Button>
                        <Button variant="passive" buttonStyle="borderless" onClick={onCancelClick} type="button">
                            {"Cancel"}
                        </Button>
                    </div>
                </div>
            )}
            {showAll && (
                <div className="mb-4">
                    <SearchInput
                        minLength={0}
                        // debounceTimeout={300}
                        value={searchFilter}
                        onChange={(event) => setSearchFilter(event.target.value)}
                        className="form-control searchForm w-100"
                        placeholder="Search..."
                        id="kt_datatable_search_query"
                    />
                </div>
            )}
            <div className="mb-6">
                {orderedData && orderedData.length > 0 ? (
                    <div className="d-flex flex-wrap" style={{ gap: "8px" }}>
                        {orderedData.slice(0, numOfFiltersToDisplay).map((filter, i) => {
                            const isEditing = filter.id === editingFilterId;
                            const iconColor = filter.id === activeFilterId ? "white" : "#305073";
                            return (
                                <div
                                    key={`users__filter__${i}`}
                                    className={`d-flex align-items-center existingFilter ${
                                        filter.id === activeFilterId ? "active" : ""
                                    }`}
                                    style={{ cursor: isEditing ? "default" : "pointer" }}
                                    onClick={() => {
                                        if (!isEditing) {
                                            if (filter.id === activeFilterId) {
                                                clearAllFilters();
                                            } else {
                                                onFilterSelected(filter);
                                            }
                                        }
                                    }}
                                >
                                    {isEditing ? (
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                className="p-0 border-0 bg-transparent"
                                                style={{
                                                    outline: "none",
                                                    color: filter.id === activeFilterId ? "white" : "#305073",
                                                }}
                                                value={editingFilterName || ""}
                                                onChange={(e) => setEditingFilterName(e.target.value)}
                                                autoFocus
                                                onClick={(e) => e.stopPropagation()}
                                                onKeyDown={(e) => {
                                                    if (e.key === "Enter") handleRenameSubmit(e);
                                                    if (e.key === "Escape") handleRenameCancel(e);
                                                }}
                                            />
                                            <span onClick={handleRenameSubmit} className="ml-2 cursor-pointer d-flex">
                                                <SVG
                                                    src={toAbsoluteUrl("/media/svg/icons/General/check.svg")}
                                                    style={{ transform: "rotate(0deg)", width: "12px", height: "12px" }}
                                                />
                                            </span>
                                            <span onClick={handleRenameCancel} className="ml-2 cursor-pointer d-flex">
                                                <SVG
                                                    src={toAbsoluteUrl("/media/svg/popleads/plus.svg")}
                                                    style={{
                                                        transform: "rotate(45deg)",
                                                        width: "12px",
                                                        height: "12px",
                                                    }}
                                                />
                                            </span>
                                        </div>
                                    ) : (
                                        <>
                                            <span className="mr-2 text-break">{filter.name}</span>
                                            <span
                                                className="mr-2 cursor-pointer d-flex p-1"
                                                onClick={(e) => onRenameClicked(e, filter)}
                                            >
                                                <svg
                                                    xmlns="http://www.w3.org/2000/svg"
                                                    viewBox="0 0 24 24"
                                                    width="12"
                                                    height="12"
                                                    style={{
                                                        transform: "rotate(0deg)",
                                                        pointerEvents: "none",
                                                        color: iconColor,
                                                        stroke: iconColor,
                                                        opacity: 1,
                                                    }}
                                                >
                                                    <path
                                                        d="M12 20h9"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                    <path
                                                        d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"
                                                        fill="none"
                                                        stroke="currentColor"
                                                        strokeWidth="2"
                                                        strokeLinecap="round"
                                                        strokeLinejoin="round"
                                                    />
                                                </svg>
                                            </span>
                                            <span
                                                className="cursor-pointer d-flex"
                                                onClick={(e) => onDeleteClicked(e, filter.id)}
                                            >
                                                <SVG
                                                    src={toAbsoluteUrl("/media/svg/popleads/delete.svg")}
                                                    style={{
                                                        transform: "rotate(0deg)",
                                                        width: "12px",
                                                        height: "12px",
                                                        color: iconColor,
                                                        stroke: iconColor,
                                                        opacity: 1,
                                                    }}
                                                />
                                            </span>
                                        </>
                                    )}
                                </div>
                            );
                        })}
                        {orderedData.length > numOfFiltersToDisplay && (
                            <div className="d-flex align-items-center" onClick={() => setShowAll(true)}>
                                <span className="mr-2 btn-filters saveFilter  cursor-pointer">Show More...</span>
                            </div>
                        )}
                        {showAll && !isSearching && (
                            <div className="d-flex align-items-center" onClick={() => setShowAll(false)}>
                                <span className="mr-2 btn-filters saveFilter  cursor-pointer">Show Less...</span>
                            </div>
                        )}
                    </div>
                ) : (
                    searchFilter && <div className="color-warning">There is no saved filter found!</div>
                )}
            </div>
        </>
    );
};

export default SaveFilter;
